import { Star, Heart, Compass, Briefcase, Sprout } from "lucide-react";
import { useTranslation } from 'react-i18next';

export const cardItems = [
    { id: 0, label: "The Fool", description: "A new journey begins, full of possibilities." },
    { id: 1, label: "The Magician", description: "Manifestation and mastery over elements." },
    { id: 2, label: "The High Priestess", description: "Intuition and hidden knowledge." },
    { id: 3, label: "The Empress", description: "Fertility, creativity, and abundance." },
    { id: 4, label: "The Emperor", description: "Authority and structure." },
    { id: 5, label: "The Hierophant", description: "Tradition and spiritual guidance." },
    { id: 6, label: "The Lovers", description: "Union and choices in relationships." },
    { id: 7, label: "The Chariot", description: "Victory through determination." },
    { id: 8, label: "Strength", description: "Inner power and resilience." },
    { id: 9, label: "The Hermit", description: "Soul searching and inner wisdom." },
    { id: 10, label: "Wheel of Fortune", description: "Cycles of fate and luck." },
    { id: 11, label: "Justice", description: "Truth and balance." },
    { id: 12, label: "The Hanged Man", description: "New perspectives through sacrifice." },
    { id: 13, label: "Death", description: "Transformation and endings." },
    { id: 14, label: "Temperance", description: "Balance and harmony." },
    { id: 15, label: "The Devil", description: "Temptation and materialism." },
    { id: 16, label: "The Tower", description: "Sudden change and upheaval." },
    { id: 17, label: "The Star", description: "Hope and inspiration." },
    { id: 18, label: "The Moon", description: "Illusions and the subconscious." },
    { id: 19, label: "The Sun", description: "Success and joy." },
    { id: 20, label: "Judgment", description: "Awakening and rebirth." },
    { id: 21, label: "The World", description: "Completion and wholeness." },

    // Suit of Cups
    ...Array.from({ length: 14 }, (_, i) => ({ id: 22 + i, label: `Cups ${i + 1}`, description: `Description for Cups ${i + 1}` })),

    // Suit of Pentacles
    ...Array.from({ length: 14 }, (_, i) => ({ id: 36 + i, label: `Pentacles ${i + 1}`, description: `Description for Pentacles ${i + 1}` })),

    // Suit of Swords
    ...Array.from({ length: 14 }, (_, i) => ({ id: 50 + i, label: `Swords ${i + 1}`, description: `Description for Swords ${i + 1}` })),

    // Suit of Wands
    ...Array.from({ length: 14 }, (_, i) => ({ id: 64 + i, label: `Wands ${i + 1}`, description: `Description for Wands ${i + 1}` })),

];

export const useCategoryItems = () => {
    const { t } = useTranslation();

    return [
        { id: 'general', icon: Compass, label: t('readingTypes.categories.general') },
        { id: 'spiritual', icon: Star, label: t('readingTypes.categories.spiritual') },
        { id: 'love', icon: Heart, label: t('readingTypes.categories.love') },
        { id: 'career', icon: Briefcase, label: t('readingTypes.categories.career') },
        { id: 'personal-growth', icon: Sprout, label: t('readingTypes.categories.personal-growth') },
        /*     { id: 'shadow-work', icon: Moon, label: t('readingTypes.categories.shadow-work') }*/
    ];
};

export const useSpreadTypes = () => {
    const { t } = useTranslation();

    return {
        "general": [
            {
                "type": "one-card-reading",
                "setup": [0, 1, 0],
                "label": t('readingTypes.spreads.general.daily-reading.label'),
                "questions": t('readingTypes.spreads.general.daily-reading.questions', { returnObjects: true }),
                "id": "daily-reading",
                "description": t('readingTypes.spreads.general.daily-reading.description'),
                "totalCards": 1,
                "count": 1,
                "credits": 1
            },
            {
                "type": "three-card",
                "setup": [0, 1, 2],
                "label": t('readingTypes.spreads.general.past-present-future.label'),
                "questions": t('readingTypes.spreads.general.past-present-future.questions', { returnObjects: true }),
                "id": "past-present-future",
                "description": t('readingTypes.spreads.general.past-present-future.description'),
                "totalCards": 3,
                "count": 3,
                "credits": 2
            },
            {
                "type": "three-card",
                "setup": [0, 1, 2],
                "label": t('readingTypes.spreads.general.situation-action-outcome.label'),
                "questions": t('readingTypes.spreads.general.situation-action-outcome.questions', { returnObjects: true }),
                "id": "situation-action-outcome",
                "description": t('readingTypes.spreads.general.situation-action-outcome.description'),
                "totalCards": 3,
                "count": 3,
                "credits": 2
            },
            {
                "type": "three-card",
                "setup": [0, 1, 2],
                "label": t('readingTypes.spreads.general.idea-process-aspiration.label'),
                "questions": t('readingTypes.spreads.general.idea-process-aspiration.questions', { returnObjects: true }),
                "id": "idea-process-aspiration",
                "description": t('readingTypes.spreads.general.idea-process-aspiration.description'),
                "totalCards": 3,
                "count": 3,
                "credits": 2
            },
            {
                "type": "three-card",
                "setup": [0, 1, 2],
                "label": t('readingTypes.spreads.general.stop-start-continue.label'),
                "questions": t('readingTypes.spreads.general.stop-start-continue.questions', { returnObjects: true }),
                "id": "stop-start-continue",
                "description": t('readingTypes.spreads.general.stop-start-continue.description'),
                "totalCards": 3,
                "count": 3,
                "credits": 2
            },
            {
                "type": "three-card",
                "setup": [0, 1, 2],
                "label": t('readingTypes.spreads.general.problem-cause-solution.label'),
                "questions": t('readingTypes.spreads.general.problem-cause-solution.questions', { returnObjects: true }),
                "id": "problem-cause-solution",
                "description": t('readingTypes.spreads.general.problem-cause-solution.description'),
                "totalCards": 3,
                "count": 3,
                "credits": 2
            },
            {
                "type": "three-card",
                "setup": [0, 1, 2],
                "label": t('readingTypes.spreads.general.opportunity-obstacle-potential.label'),
                "questions": t('readingTypes.spreads.general.opportunity-obstacle-potential.questions', { returnObjects: true }),
                "id": "opportunity-obstacle-potential",
                "description": t('readingTypes.spreads.general.opportunity-obstacle-potential.description'),
                "totalCards": 3,
                "count": 3,
                "credits": 2
            },
            {
                "type": "celtic-cross",
                "setup": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
                "layout": "cross",
                "label": t('readingTypes.spreads.general.celtic-cross.label'),
                "questions": t('readingTypes.spreads.general.celtic-cross.questions', { returnObjects: true }),
                "id": "celtic-cross",
                "description": t('readingTypes.spreads.general.celtic-cross.description'),
                "totalCards": 10,
                "count": 10,
                "credits": 3
            },
            {
                "type": "horseshoe-spread",
                "setup": [1, 2, 3, 4, 5, 6, 7],
                "layout": "arc",
                "label": t('readingTypes.spreads.general.horseshoe-spread.label'),
                "questions": t('readingTypes.spreads.general.horseshoe-spread.questions', { returnObjects: true }),
                "id": "horseshoe-spread",
                "description": t('readingTypes.spreads.general.horseshoe-spread.description'),
                "totalCards": 7,
                "count": 7,
                "credits": 5
            },
            {
                "type": "tetraktys-spread",
                "setup": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
                "layout": "pyramid",
                "label": t('readingTypes.spreads.general.tetraktys-spread.label'),
                "questions": t('readingTypes.spreads.general.tetraktys-spread.questions', { returnObjects: true }),
                "id": "tetraktys-spread",
                "description": t('readingTypes.spreads.general.tetraktys-spread.description'),
                "totalCards": 10,
                "count": 10,
                "credits": 5
            }
        ],
        "love": [
            {
                "type": "three-card",
                "setup": [0, 1, 2],
                "label": t('readingTypes.spreads.love.finding-the-one.label'),
                "questions": t('readingTypes.spreads.love.finding-the-one.questions', { returnObjects: true }),
                "id": "finding-the-one",
                "description": t('readingTypes.spreads.love.finding-the-one.description'),
                "totalCards": 3,
                "count": 3,
                "credits": 2
            },
            {
                "type": "three-card",
                "setup": [0, 1, 2],
                "label": t('readingTypes.spreads.love.you-relationship-partner.label'),
                "questions": t('readingTypes.spreads.love.you-relationship-partner.questions', { returnObjects: true }),
                "id": "you-relationship-partner",
                "description": t('readingTypes.spreads.love.you-relationship-partner.description'),
                "totalCards": 3,
                "count": 3,
                "credits": 2
            },
            {
                "type": "three-card",
                "setup": [3, 5, 1, 4, 7],
                "layout": "cross",
                "label": t('readingTypes.spreads.love.relationship-spread.label'),
                "questions": t('readingTypes.spreads.love.relationship-spread.questions', { returnObjects: true }),
                "id": "relationship-spread",
                "description": t('readingTypes.spreads.love.relationship-spread.description'),
                "totalCards": 5,
                "count": 5,
                "credits": 2
            }
        ],
        "spiritual": [
            {
                "type": "three-card",
                "setup": [0, 1, 2],
                "label": t('readingTypes.spreads.spiritual.mind-body-spirit.label'),
                "questions": t('readingTypes.spreads.spiritual.mind-body-spirit.questions', { returnObjects: true }),
                "id": "mind-body-spirit",
                "description": t('readingTypes.spreads.spiritual.mind-body-spirit.description'),
                "totalCards": 3,
                "count": 3,
                "credits": 2
            },
            {
                "type": "tree-of-life",
                "setup": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
                "layout": "tree-of-life",
                "label": t('readingTypes.spreads.spiritual.tree-of-life-spread.label'),
                "questions": t('readingTypes.spreads.spiritual.tree-of-life-spread.questions', { returnObjects: true }),
                "id": "tree-of-life-spread",
                "description": t('readingTypes.spreads.spiritual.tree-of-life-spread.description'),
                "totalCards": 10,
                "count": 10,
                "credits": 5
            }
        ],
        "career": [
            {
                "type": "three-card",
                "setup": [0, 1, 2],
                "label": t('readingTypes.spreads.career.leadership-tarot-spread.label'),
                "questions": t('readingTypes.spreads.career.leadership-tarot-spread.questions', { returnObjects: true }),
                "id": "leadership-tarot-spread",
                "description": t('readingTypes.spreads.career.leadership-tarot-spread.description'),
                "totalCards": 3,
                "count": 3,
                "credits": 2
            },
            {
                "type": "astrological-spread",
                "setup": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
                "layout": "circle",
                "label": t('readingTypes.spreads.career.astrological-spread.label'),
                "questions": t('readingTypes.spreads.career.astrological-spread.questions', { returnObjects: true }),
                "id": "astrological-spread",
                "description": t('readingTypes.spreads.career.astrological-spread.description'),
                "totalCards": 13,
                "count": 13,
                "credits": 7
            }
        ],
        "personal-growth": [
            {
                "type": "three-card",
                "setup": [0, 1, 2],
                "label": t('readingTypes.spreads.personal-growth.you-your-path-your-potential.label'),
                "questions": t('readingTypes.spreads.personal-growth.you-your-path-your-potential.questions', { returnObjects: true }),
                "id": "you-your-path-your-potential",
                "description": t('readingTypes.spreads.personal-growth.you-your-path-your-potential.description'),
                "totalCards": 3,
                "count": 3,
                "credits": 2
            },
            {
                "type": "three-card",
                "setup": [0, 1, 2],
                "label": t('readingTypes.spreads.personal-growth.spread-to-find-direction.label'),
                "questions": t('readingTypes.spreads.personal-growth.spread-to-find-direction.questions', { returnObjects: true }),
                "id": "spread-to-find-direction",
                "description": t('readingTypes.spreads.personal-growth.spread-to-find-direction.description'),
                "totalCards": 3,
                "count": 3,
                "credits": 2
            },
            {
                "type": "year-ahead-spread",
                "setup": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
                "layout": "year-ahead",
                "label": t('readingTypes.spreads.personal-growth.year-ahead-spread.label'),
                "questions": t('readingTypes.spreads.personal-growth.year-ahead-spread.questions', { returnObjects: true }),
                "id": "year-ahead-spread",
                "description": t('readingTypes.spreads.personal-growth.year-ahead-spread.description'),
                "totalCards": 12,
                "count": 12,
                "credits": 7
            }
        ],
        /* "shadow-work": [
             {
                 "type": "three-card",
                 "setup": [0, 1, 2],
                 "label": t('readingTypes.spreads.shadow-work.give-it-to-me-straight.label'),
                 "questions": t('readingTypes.spreads.shadow-work.give-it-to-me-straight.questions', { returnObjects: true }),
                 "id": "give-it-to-me-straight",
                 "description": t('readingTypes.spreads.shadow-work.give-it-to-me-straight.description'),
                 "totalCards": 3,
                 "count": 3
             }
         ]*/
    }
};

// Legacy exports for backward compatibility
export const categoryItems = [
    { icon: Compass, label: 'general' },
    { icon: Star, label: 'spiritual' },
    { icon: Heart, label: 'love' },
    { icon: Briefcase, label: 'career' },
    { icon: Sprout, label: 'personal-growth' },
    /*   { icon: Moon, label: 'shadow-work' }*/
];

export const spreadTypes = {
    "general": [
        {
            type: "three-card",
            setup: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            label: "Planetary Alignments",
            id: "planetary-alignments",
            description: "Explore how the current planetary positions are influencing your path.",
            totalCards: 9,
            count: 9
        },
        {
            type: "three-card",
            setup: [4],
            label: "Solar Return",
            id: "solar-return",
            description: "Gain insight into your personal year ahead as the Sun returns to its natal position.",
            totalCards: 9,
            count: 1
        },
        {
            type: "three-card",
            setup: [3, 5],
            label: "Lunar Nodes",
            id: "lunar-nodes",
            description: "Understand your soul's journey through the karmic axis of the North and South nodes.",
            totalCards: 9,
            count: 2
        },
        {
            type: "three-card",
            setup: [0, 2, 4, 6, 8],
            label: "Grand Cross Reading",
            id: "grand-cross-reading",
            description: "Navigate challenges and opportunities presented by challenging planetary aspects.",
            totalCards: 9,
            count: 5
        }],
    "spiritual": [
        {
            type: "three-card",
            setup: [0, 1, 2, 3, 4],
            label: "Chakra Alignment",
            id: "chakra-alignment",
            description: "Explore the balance and flow of your seven main energy centers through spiritual guidance.",
            totalCards: 9,
            count: 5
        },
        {
            type: "three-card",
            setup: [0, 2, 4, 6, 8],
            label: "Spirit Guide Connection",
            id: "spirit-guide-connection",
            description: "Open channels of communication with your spiritual guides and receive their messages.",
            totalCards: 9,
            count: 5
        },
        {
            type: "three-card",
            setup: [1, 3, 5, 7],
            label: "Past Life Reading",
            id: "past-life-reading",
            description: "Uncover karmic patterns and soul lessons from your previous incarnations.",
            totalCards: 9,
            count: 4
        },
        {
            type: "three-card",
            setup: [0, 4, 8],
            label: "Higher Self Alignment",
            id: "higher-self-alignment",
            description: "Connect with your highest spiritual essence and receive guidance for your path.",
            totalCards: 9,
            count: 3
        }],
    "love": [
        {
            type: "three-card",
            setup: [1, 4, 7],
            label: "Sacred Triangle",
            id: "sacred-triangle",
            description: "Reveal the divine geometry in your life path through an ancient triangular spread.",
            totalCards: 9,
            count: 3
        },
        {
            type: "three-card",
            setup: [0, 1, 2, 3, 4, 5, 6, 7, 8],
            label: "Cosmic Grid",
            id: "cosmic-grid",
            description: "Map your soul's journey through nine celestial houses of transformation.",
            totalCards: 9,
            count: 9
        },
        {
            type: "three-card",
            setup: [0, 3, 4, 5, 8],
            label: "Crystal Cross",
            id: "crystal-cross",
            description: "Channel crystal energies through a powerful cross formation for clarity and healing.",
            totalCards: 9,
            count: 5
        },
        {
            type: "three-card",
            setup: [1, 3, 4, 5, 7],
            label: "Elements Gateway",
            id: "elements-gateway",
            description: "Open portals to the elemental realms for deep spiritual communion and guidance.",
            totalCards: 9,
            count: 5
        }],
    "career": [
        {
            type: "three-card",
            setup: [0, 1, 2],
            label: "Professional Path Oracle",
            id: "professional-path-oracle",
            description: "Illuminate your career destiny through ancient wisdom and cosmic guidance.",
            totalCards: 9,
            count: 3
        },
        {
            type: "three-card",
            setup: [0, 4, 8],
            label: "Success Triangle",
            id: "success-triangle",
            description: "Unveil the three pillars of your professional ascension and material abundance.",
            totalCards: 9,
            count: 3
        },
        {
            type: "three-card",
            setup: [1, 3, 5, 7],
            label: "Leadership Mandala",
            id: "leadership-mandala",
            description: "Discover your innate leadership qualities through sacred geometric patterns.",
            totalCards: 9,
            count: 4
        },
        {
            type: "three-card",
            setup: [0, 2, 4, 6, 8],
            label: "Abundance Pentagram",
            id: "abundance-pentagram",
            description: "Activate the five points of professional mastery and material manifestation.",
            totalCards: 9,
            count: 5
        }],
    "personal-growth": [
        {
            type: "three-card",
            setup: [0, 1, 2, 3],
            label: "Inner Alchemy",
            id: "inner-alchemy",
            description: "Transform base consciousness into spiritual gold through ancient wisdom.",
            totalCards: 9,
            count: 4
        },
        {
            type: "three-card",
            setup: [0, 4, 8],
            label: "Wisdom Triad",
            id: "wisdom-triad",
            description: "Access the threefold path of self-knowledge, acceptance, and transformation.",
            totalCards: 9,
            count: 3
        },
        {
            type: "three-card",
            setup: [1, 3, 5, 7],
            label: "Shadow Integration",
            id: "shadow-integration",
            description: "Embrace your hidden aspects through the lens of spiritual evolution.",
            totalCards: 9,
            count: 4
        },
        {
            type: "three-card",
            setup: [0, 2, 4, 6, 8],
            label: "Virtue Pentagon",
            id: "virtue-pentagon",
            description: "Cultivate the five cardinal virtues of the enlightened soul.",
            totalCards: 9,
            count: 5
        }],
    "shadow-work": [
        {
            type: "three-card",
            setup: [0, 1, 2],
            label: "Dark Night Oracle",
            id: "dark-night-oracle",
            description: "Navigate the depths of your psyche through mystical shadow work.",
            totalCards: 9,
            count: 3
        },
        {
            type: "three-card",
            setup: [0, 4, 8],
            label: "Underworld Journey",
            id: "underworld-journey",
            description: "Descend into the sacred darkness to retrieve lost parts of your soul.",
            totalCards: 9,
            count: 3
        },
        {
            type: "three-card",
            setup: [1, 3, 5, 7],
            label: "Shadow Mirror",
            id: "shadow-mirror",
            description: "Face your reflections in the obsidian mirror of self-discovery.",
            totalCards: 9,
            count: 4
        },
        {
            type: "three-card",
            setup: [0, 2, 4, 6, 8],
            label: "Phoenix Rising",
            id: "phoenix-rising",
            description: "Transform through the alchemical fires of shadow integration.",
            totalCards: 9,
            count: 5
        }]
}